import { Navigate, useNavigate, useParams } from "react-router-dom";
import { SnackbarProvider, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import Axios from "axios";
import Brackground from "../../../components/Background";
import Confirm from "@mui/material/Dialog";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import Navbar from "../../../components/Navbar";
import Paralisacao from "@mui/material/Dialog";
import ParalisacaoFim from "@mui/material/Dialog";
import Pesagem from "@mui/material/Dialog";
import React from "react";
import confirm from "./Confirm.module.css";
import modal from "./Modal.module.css";
import moment from "moment";
import style from "./Operacao.module.css";
import { PersonRemoveSharp } from "@mui/icons-material";
import jsPDF from "jspdf";
import InputMask from "react-input-mask";
import seloBase64 from "./SeloBase64";
import placaMercosul from "./PlacaMercosulBase64";
import placaMercosulBase64 from "./PlacaMercosulBase64";

const Operacao = () => {
  useEffect(() => {
    DadosDashboard();
    getVeiculos();
    getQtDescarregado();
    getAlerta();
    getQtDescarregadom();
    getQtDescarregadoh();
    getSaldom();
    getMotivos();
    getTotalSaldo();
    VerificaParalisacao();
    getComplementos();
    getCargas();
    getTipoveiculo();
    getTransportadora();
    getDocdibl();
    getDocumentos();
    getDocs();
    getPedido();
    getDiCarga();
  }, []);

  useEffect(() => {
    const interval_1 = setInterval(() => {
      DadosDashboard();
      getVeiculos();
      getQtDescarregado();
      getQtDescarregadom();
      getQtDescarregadoh();
      getSaldom();
      getTotalSaldo();
      getMotivos();
      VerificaParalisacao();
      getComplementos();
    }, 1500);

    return () => clearInterval(interval_1); //This is important
  }, []);

  const navigate = useNavigate();
  let { id } = useParams();

  const [busca, setBusca] = useState("");

  const [existeParalisacao, setExisteParalisacao] = useState(0);
  const [dadosDash, setDadosDash] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [paralisacoes, setParalisacoes] = useState([]);
  const [descarregado, setDescarregado] = useState([]);
  const [alerta, setAlerta] = useState([]);
  const [descarregadoh, setDescarregadoh] = useState([]);
  const [saldo, setSaldo] = useState([]);
  const [descarregadom, setDescarregadom] = useState([]);
  const [saldom, setSaldom] = useState([]);
  const [docs, setDocs] = useState([]);
  const [doc, setDoc] = useState("");
  const [mostrarProvisorio, setMostrarProvisorio] = useState(false);
  const [pesoProvisorio, setPesoProvisorio] = useState("");
  const [dataProvisorio, setDataProvisorio] = useState("");

  const [porao, setPorao] = useState("");
  const [motivos, setMotivos] = useState([]);
  const [complementos, setComplementos] = useState([]);
  const [motivo, setMotivo] = useState("");
  const [complemento, setComplemento] = useState("");
  const [dtinicio, setDtinicio] = useState("");
  const [obs, setObs] = useState("");
  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  const [i, setI] = useState({});
  const [peso2, setPeso2] = useState("");
  const [ticket, setTicket] = useState("");
  const [data, setData] = useState();
  const [obsPesagem, setObsPesagem] = useState("");

  const [dataFim, setDataFim] = useState("");
  const [dataFimPara, setDataFimPara] = useState("");

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);

  const [mostaInput1, setMostaInput1] = useState(false);
  const [mostaInput2, setMostaInput2] = useState(false);
  const [mostaInput3, setMostaInput3] = useState(false);
  const [mostaInput4, setMostaInput4] = useState(false);
  const [mostaInput5, setMostaInput5] = useState(false);
  const [mostaInput6, setMostaInput6] = useState(false);
  const [mostaInput7, setMostaInput7] = useState(false);
  const [mostaInput8, setMostaInput8] = useState(false);
  const [mostaInput9, setMostaInput9] = useState(false);
  const [mostaInput10, setMostaInput10] = useState(false);
  const [mostaInput11, setMostaInput11] = useState(false);
  const [mostaInput12, setMostaInput12] = useState(false);
  const [mostaInput13, setMostaInput13] = useState(false);
  const [viewMode, setViewMode] = useState("MOEGA");

  const [mostrarPesoProvisorio, setMostrarPesoProvisorio] = useState(false);
  const [pesoProvisorioTemp, setPesoProvisorioTemp] = useState(pesoProvisorio);
  const [mostrarDataProvisorioPY, setMostrarDataProvisorioPY] = useState(false);
  const [dataProvisorioPYTemp, setDataProvisorioPYTemp] =
    useState(dataProvisorio);

  const [dataPy, setDataPy] = useState([
    { PESO_CARREGADO_PY: "", DATA_CARREGAMENTO_PY: "", USUARIO_CARREG_PY: "" },
  ]);
  const [pedidos, setPedidos] = useState([]);
  const [dicargas, setDiCargas] = useState([]);
  const [pedido, setPedido] = useState("");
  const [documento, setDocumento] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [placaCavalo, setPlacaCavalo] = useState("");
  const [placa1, setPlaca1] = useState("");
  const [placa2, setPlaca2] = useState("");
  const [placa3, setPlaca3] = useState("");
  const [minuta, setMinuta] = useState("");
  const [observacao, setObservacao] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [tara, setTara] = useState("");
  const [dataTara, setDataTara] = useState("");
  const [tipoveiculos, setTipoveiculos] = useState([]);
  const [transportadora, setTransportadora] = useState([]);
  const [transportadoras, setTransportadoras] = useState([]);
  const [tipoveiculo, setTipoveiculo] = useState([]);
  const [docdibl, setDocdibl] = useState([]);
  const [docsdibl, setDocsdibl] = useState([]);

  const [mostrarGifAdesivo, setMostrarGifAdesivo] = useState(false);

  const abrirGifAdesivo = () => setMostrarGifAdesivo(true);
  const fecharGifAdesivo = () => setMostrarGifAdesivo(false);

  //modal de 2 pesagem
  const [openA, setOpenA] = useState(false);
  const AbrirPesagem = () => {
    setOpenA(true);
  };
  const FecharPesagem = () => {
    setOpenA(false);
    setData("");
    setPeso2("");
  };

  const [openC, setOpenC] = useState(false);
  const AbrirConfirm = () => {
    setOpenC(true);
  };
  const FecharConfirm = () => {
    setOpenC(false);
  };

  const [MostaInput, setMostaInput] = useState(false);

  const divClick = () => {
    setMostaInput(true);
  };

  const toggleProvisorio = (id) => {
    setMostrarProvisorio((prevProvisorio) => ({
      ...prevProvisorio,
      [id]: !prevProvisorio[id],
    }));
  };

  //modal de paralisacao
  const [openB, setOpenB] = useState(false);
  const AbrirParalisacao = () => {
    setOpenB(true);
  };
  const FecharParalisacao = () => {
    setOpenB(false);
  };

  const [openD, setOpenD] = useState(false);
  const AbrirParalisacaoFim = () => {
    setOpenD(true);
  };
  const FecharParalisacaoFim = () => {
    setOpenD(false);
    setDataFimPara("");
  };

  const editarPesoProvisorio = () => {
    setMostrarPesoProvisorio(true);
  };

  const salvarPesoProvisorio = () => {
    setPesoProvisorio(pesoProvisorioTemp);
    setMostrarPesoProvisorio(false);
    // Adicione aqui a lógica para salvar o valor no backend se necessário
  };

  const cancelarEdicaoPesoProvisorio = () => {
    setPesoProvisorioTemp(pesoProvisorio); // Restaura o valor original
    setMostrarPesoProvisorio(false);
  };

  const editarDataProvisorioPY = () => {
    setMostrarDataProvisorioPY(true);
  };

  const salvarDataProvisorioPY = () => {
    setDataProvisorio(dataProvisorioPYTemp);
    setMostrarDataProvisorioPY(false);
    // Adicione aqui a lógica para salvar o valor no backend se necessário
  };

  const cancelarEdicaoDataProvisorioPY = () => {
    setDataProvisorioPYTemp(dataProvisorio); // Restaura o valor original
    setMostrarDataProvisorioPY(false);
  };

  const getTipoveiculo = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/tipoveiculo`).then(
      function (res) {
        setTipoveiculos(res.data);
      }
    );
  };

  const getTransportadora = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/transportadora`).then(
      function (res) {
        setTransportadoras(res.data);
      }
    );
  };

  const getDocdibl = () => {
    const url = window.location.href; // Obtém a URL atual do navegador
    const parts = url.split("/api/"); // Divide a URL em partes usando a barra como delimitador
    const idOperacao = parts[parts.length - 1]; // Obtém a parte final da URL (o ID da operação)

    Axios.get(`https://operacao.setlogistica.com.br/api/carga/${idOperacao}`)
      .then(function (res) {
        setDocsdibl(res.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const getDocumentos = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/documento/${id}`).then(
      function (res) {
        setDocumentos(res.data);
      }
    );
  };

  const getCargas = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/carga/busca/${id}`
    ).then(function (res) {
      setDocs(res.data);
    });
  };

  const getDate = () => {
    const date = new Date();
    date.setHours(date.getHours() - 3);
    return date.toISOString().slice(0, 19).replace("T", " ");
  };

  const VerificaParalisacao = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/verifica/paralisacao/${id}`
    ).then(function (res) {
      setExisteParalisacao(res.data);
    });
  };

  const [dis, setDis] = useState([]);
  const getDocs = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/carga/busca/${id}`
    ).then(function (res) {
      setDis(res.data);
    });
  };

  const getPedido = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/buscar/pedidos/${id}`
    ).then(function (res) {
      setPedidos(res.data);
    });
  };

  const getDiCarga = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/buscar/cargas/${id}`
    ).then(function (res) {
      setDiCargas(res.data);
    });
  };

  const DadosDashboard = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/periodo/dashboard/${id}`
    ).then(function (res) {
      setDadosDash(res.data[0]);
      Axios.get(
        `https://operacao.setlogistica.com.br/api/paralisacao/periodo/${res.data[0].SEQ_PERIODO_OP}`
      ).then(function (res) {
        setParalisacoes(res.data);
      });
    });
  };
  const getVeiculos = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/veiculos/${id}`
    ).then(function (res) {
      setVeiculos(res.data);
    });
  };

  const getVeiculoAtual = () => {
    return (
      veiculos.find((item) => item.ID_CARREGAMENTO === i.ID_CARREGAMENTO) || i
    );
  };

  const getQtDescarregado = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/descarregado/${id}`
    ).then(function (res) {
      setDescarregado(res.data[0].DESCARREGADO);
    });
  };

  const getQtDescarregadoh = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/descarregadoh/${id}`
    ).then(function (res) {
      setDescarregadoh(res.data[0].DESCARREGADOH);
    });
  };

  const getAlerta = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/operacao/alerta/${id}`)
      .then(function (res) {
        setAlerta(res.data);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const getQtDescarregadom = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/descarregadom/${id}`
    ).then(function (res) {
      setDescarregadom(res.data[0].DESCARREGADOM);
    });
  };

  const getSaldom = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/saldom/${id}`
    ).then(function (res) {
      setSaldom(res.data[0].SALDOM);
    });
  };

  const getTotalSaldo = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/dashboard/saldo/${id}`
    ).then(function (res) {
      setSaldo(res.data[0].SALDO);
    });
  };

  const getMotivos = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/motivos`).then(
      function (res) {
        setMotivos(res.data);
      }
    );
  };
  const getComplementos = () => {
    Axios.get(`https://operacao.setlogistica.com.br/api/complementos`).then(
      function (res) {
        setComplementos(res.data);
      }
    );
  };

  const addParalisacao = () => {
    Axios.post("https://operacao.setlogistica.com.br/api/paralisacao/criar", {
      operacao: id,
      periodo: dadosDash.SEQ_PERIODO_OP,
      motivo: motivo,
      obs: obs,
      dtinicio: dtinicio,
      usuario: usuario,
      dtcadastro: getDate(),
    }).then(function (res) {
      if (res.data.sqlMessage) showAlert(res.data.sqlMessage, "error");
      else {
        showAlert("Paralisação adicionada!", "success");
      }
    });
    FecharParalisacao();
    dadosDash();
  };

  const [inputs, setInputs] = useState([
    {
      name: "Nome do motorista:",
      id: 1,
      value: `${i.NOME_MOTORISTA}`,
      show: false,
    },
    {
      name: "Placa do calvalo: ",
      id: 2,
      value: `${i.PLACA_CAVALO}`,
      show: false,
    },
    {
      name: "Placa da carreta 1: ",
      id: 3,
      value: `${i.PLACA_CARRETA}`,
      show: false,
    },
    {
      name: "Placa da carreta 2:",
      id: 4,
      value: `${i.PLACA_CARRETA2}`,
      show: false,
    },
    {
      name: "Placa da carreta 3:",
      id: 5,
      value: `${i.PLACA_CARRETA3}`,
      show: false,
    },
    { name: "1º peso (tara):", id: 6, value: `${i.PESO_TARA}`, show: false },
    { name: "Pedido MIC:", id: 7, value: `${i.PEDIDO_MIC}`, show: false },
    { name: "Minuta:", id: 8, value: `${i.MINUTA}`, show: false },
    { name: "Observação:", id: 9, value: `${i.OBS_CARREGAMENTO}`, show: false },
    { name: "Whatsapp:", id: 10, value: `${i.CELULAR_MOTORISTA}`, show: false },
    {
      name: "Produto:",
      id: 10,
      value: `${i.NOME_REDUZIDO_PRODUTO}`,
      show: false,
    },
  ]);

  const handleDivClick = (id) => {
    const newInputs = [...inputs];
    const index = newInputs.findIndex((input) => input.id === id);
    newInputs[index].show = !newInputs[index].show;
    setInputs(newInputs);
  };

  const divClick2 = () => {
    setMostaInput2(true);
  };
  const divClick3 = () => {
    setMostaInput3(true);
  };
  const divClick4 = () => {
    setMostaInput4(true);
  };
  const divClick5 = () => {
    setMostaInput5(true);
  };
  const divClick6 = () => {
    setMostaInput6(true);
  };
  const divClick7 = () => {
    setMostaInput7(true);
  };
  const divClick8 = () => {
    setMostaInput8(true);
  };
  const divClick9 = () => {
    setMostaInput9(true);
  };
  const divClick10 = () => {
    setMostaInput10(true);
  };
  const divClick11 = () => {
    setMostaInput11(true);
  };
  const divClick12 = () => {
    setMostaInput12(true);
  };
  const divClick13 = () => {
    setMostaInput13(true);
  };

  const toggleView = (mode) => {
    setViewMode(mode);
  };

  const copyToClipboardFallback = (text) => {
    if (!text) return;

    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        showAlert("Texto copiado com sucesso!", "success");
      } else {
        showAlert("Falha ao copiar texto.", "error");
      }
    } catch (err) {
      console.error("Erro ao copiar texto: ", err);
      showAlert("Erro ao copiar texto.", "error");
    }
    document.body.removeChild(textarea);
  };

  const validaPara = () => {
    let d1 = moment(dtinicio, "YYYY-MM-DD HH:mm:ss");
    let d2 = moment(dataFimPara, "YYYY-MM-DDTHH:mm:ss");

    if (d1.isAfter(d2)) {
      return showAlert(
        "Data de início da paralisação não pode ser posterior à data de término",
        "error"
      );
    } else {
      // Verificar a diferença total em minutos entre as duas datas
      let diffMinutes = d2.diff(d1, "minutes");

      // Se a diferença for maior que 7 horas (420 minutos), exibir erro
      if (diffMinutes > 420) {
        return showAlert(
          "A paralisação não pode durar mais de 7 horas",
          "error"
        );
      } else {
        encerrarParalisacao();
      }
    }
  };

  const encerrarParalisacao = () => {
    if (!dataFimPara) {
      showAlert("Preencha todos os campos", "error");
      return;
    }

    Axios.put("https://operacao.setlogistica.com.br/api/encerrar/paralisacao", {
      operacao: id,
      id: paralisacoes[0].SEQ_PARALISACAO,
      data: dataFimPara,
    }).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("paralisacao encerrada!", "success");
      FecharParalisacaoFim();
    });
  };

  const validaplaca3 = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/alterar/carreta3",
      {
        id: i.ID_CARREGAMENTO,
        placa: placa3,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Placa 3 alterada com sucesso!", "success");
      setMostaInput5(false);
      setOpenA(false);
    });
  };

  // Função chamada quando o usuário clica em "Reportar"
  const reportProblemas = async () => {
    try {
      const response = await Axios.put(
        "https://operacao.setlogistica.com.br/api/segundapesagem/problemas",
        {
          id: i.ID_CARREGAMENTO,
          pesoProvisorio: pesoProvisorioTemp,
          dataProvisorioPY: dataProvisorioPYTemp,
        }
      );

      if (response.data === "sucesso") {
        showAlert("Dados atualizados com sucesso!", "success");
        // Atualize o estado conforme necessário para refletir os novos valores na UI
      } else {
        showAlert("Erro ao atualizar os dados.", "error");
      }
    } catch (error) {
      console.error("Erro ao reportar problemas:", error);
      showAlert("Erro ao conectar ao servidor.", "error");
    }
  };

  const validaVeiculo = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/veiculo/atualiza",
      {
        tipoveiculo: tipoveiculo,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Veiculo alterado com sucesso!", "success");

      setMostaInput7(false);
      setOpenA(false);
    });
  };

  const validaTransportadora = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/transportadora/atualiza",
      {
        transportadora: transportadora,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Transportadora alterada com sucesso!", "success");

      setMostaInput9(false);
      setOpenA(false);
    });
  };

  const validaMinuta = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/minuta/atualiza",
      {
        minuta: minuta,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Minuta alterada com sucesso!", "success");

      setMostaInput11(false);
      setOpenA(false);
    });
  };

  const validaObservacao = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/observacao/atualiza",
      {
        observacao: observacao,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Observação alterada com sucesso!", "success");

      setMostaInput12(false);
      setOpenA(false);
    });
  };

  const validaWhatsapp = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/whatsapp/atualiza",
      {
        whatsapp: whatsapp,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Whatsapp alterada com sucesso!", "success");

      setMostaInput13(false);
      setOpenA(false);
    });
  };

  const validaDocdibl = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/docsdibl/atualiza",
      {
        docdibl: docdibl,
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Carga alterada com sucesso!", "success");

      setMostaInput10(false);
      setOpenA(false);
    });
  };

  const validaplaca2 = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/alterar/carreta2",
      {
        id: i.ID_CARREGAMENTO,
        placa: placa2,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Placa 2 alterada com sucesso!", "success");
      setMostaInput4(false);
      setOpenA(false);
    });
  };

  const validaPlaca1 = () => {
    if (!placa1) {
      showAlert("Placa 1 deve conter 7 dígitos!", "error");
      return;
    }

    atualizaPlaca1();
  };

  const atualizaPlaca1 = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/alterar/carreta1",
      {
        id: i.ID_CARREGAMENTO,
        placa: placa1,
      }
    ).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Placa 1 alterada com sucesso!", "success");
      setMostaInput3(false);
      setOpenA(false);
    });
  };

  const validaDoc = async () => {
    await Axios.put(
      "https://operacao.setlogistica.com.br/api/documentos/atualiza",
      {
        // Enviar 'documento' como string
        documento: documento.toString(),
        id: i.ID_CARREGAMENTO,
      }
    ).then(function (res) {
      if (res.data.sqlMessage) {
        showAlert(res.data.sqlMessage, "error");
      } else {
        showAlert("Pedido alterado com sucesso!", "success");
      }
      setMostaInput8(false);
      setOpenA(false);
    });
  };

  const validaCavalo = () => {
    if (!placaCavalo) {
      showAlert("Placa Cavalo deve conter 7 dígitos!", "error");
      return;
    }

    atualizaCavalo();
  };

  const atualizaCavalo = async () => {
    await Axios.put("https://operacao.setlogistica.com.br/api/alterar/cavalo", {
      id: i.ID_CARREGAMENTO,
      placa: placaCavalo,
    }).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Placa Cavalo alterada com sucesso!", "success");
      setMostaInput2(false);
      setOpenA(false);
    });
  };

  const validaTara = () => {
    if (!tara) {
      showAlert("Para atualizar a tara é necessário ter o peso!", "error");
      return;
    }
    if (!dataTara) {
      showAlert("Para atualizar a tara é necessário ter a data!", "error");
      return;
    }
    atualizaTara();
  };

  const atualizaTara = async () => {
    await Axios.put("https://operacao.setlogistica.com.br/api/alterar/tara", {
      tara: tara,
      data: dataTara,
      id: i.ID_CARREGAMENTO,
      usuario: usuario,
    }).then(function (res) {
      res.data.sqlMessage
        ? showAlert(res.data.sqlMessage, "error")
        : showAlert("Tara alterada com sucesso!", "success");
      setMostaInput6(false);
      setOpenA(false);
    });
  };

  const validaDados1 = () => {
    if (!motivo | !complemento | !dtinicio) {
      showAlert("Preencha todos os campos", "error");
      return;
    }
    addParalisacao();
  };

  const validaDados2 = () => {
    if (i.NOME_TRANSPORTADORA == "NÃO INFORMADA") {
      showAlert("Escolha a transportadora da MINUTA", "error");
      return;
    }
    if (!porao) {
      showAlert("Selecione o porão", "error");
      return;
    }
    if (!peso2 | !data) {
      showAlert(
        "Faça a INTEGRAÇÃO para computar a 2° Pesagem e a Data.",
        "error"
      );
      return;
    }
    if (
      (i.PESO_TARA >= 0 && i.PESO_TARA <= 999) ||
      (i.PESO_TARA >= 1001 && i.PESO_TARA <= 7999) ||
      i.PESO_TARA == null
    ) {
      showAlert("Registre o peso TARA corretamente", "error");
      return;
    }
    if (ticket !== String(i.ID_CARREGAMENTO)) {
      showAlert("O Ticket não corresponde ao ID de Carregamento", "error");
      return;
    }
    if (i.DESC_TIPO_VEICULO == "AGUARDANDO MODELO") {
      showAlert("É obrigatório a escolha do tipo do veículo", "error");
      return;
    }
    if (peso2 > 55000000) {
      showAlert("Peso excedido!", "error");
      return;
    }

    SegundaPesagem();
  };

  const LOGO_BASE64 =
    "data:image/png;base64,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";

  const puxarPY = () => {
    Axios.get(
      `https://operacao.setlogistica.com.br/api/puxarpy/${i.ID_CARREGAMENTO}`
    )
      .then(function (res) {
        if (!res.data[0].DATA_CARREGAMENTO_PY) {
          showAlert("Peso de integração ainda não computado!", "error");
        } else {
          // Criar a data original
          const dataCarregamento = new Date(res.data[0].DATA_CARREGAMENTO_PY);

          // Adicionar 3 horas à data original
          const dataCorrigida = new Date(
            dataCarregamento.getTime() + 3 * 60 * 60 * 1000
          );

          console.log("Data Original:", dataCarregamento.toISOString());
          console.log("Data Corrigida +3h:", dataCorrigida.toISOString());

          // Atualiza o setData com a data original
          setData(dataCarregamento.toISOString().slice(0, -2));

          // Armazena o peso
          setPeso2(res.data[0].PESO_LIQUIDO_AJUSTADO);

          // Substitua o uso de `res.data[0].DATA_CARREGAMENTO_PY` pela `dataCorrigida` no restante do código
          const doc = new jsPDF({
            orientation: "portrait",
            unit: "cm",
            format: [13, 7],
          });

          // Adicionar o logo no PDF
          doc.addImage(LOGO_BASE64, "PNG", 0.5, 0.8, 2.8, 0.8);

          // Cabeçalho e informações de endereço
          doc.setFontSize(6.5);
          doc.text("Praça dos Expedicionários, 19", 3, 0.5);
          doc.text("Sala 53 - Santos/SP", 4.1, 1);

          // Título e número do ticket
          doc.setFontSize(11);
          doc.text(
            `Ticket de Pesagem Nº ${res.data[0].ID_CARREGAMENTO}`,
            1,
            2.3
          );

          // Informações do cliente e veículo
          doc.setFontSize(9);
          doc.setFont("Helvetica", "bold");
          doc.text("MOTORISTA:", 0.5, 3);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].NOME_MOTORISTA || "N/A"}`, 2.6, 3);

          doc.setFont("Helvetica", "bold");
          doc.text("CAVA.:", 0.5, 3.5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PLACA_CAVALO || "N/A"}`, 1.8, 3.5);

          doc.setFont("Helvetica", "bold");
          doc.text("CAR.1:", 3.7, 3.5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PLACA_CARRETA || "N/A"}`, 4.9, 3.5);

          doc.setFont("Helvetica", "bold");
          doc.text("CAR.2:", 0.5, 4);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PLACA_CARRETA2 || "N/A"}`, 1.8, 4);

          doc.setFont("Helvetica", "bold");
          doc.text("CAR.3:", 3.7, 4);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PLACA_CARRETA3 || "N/A"}`, 4.9, 4);

          doc.setFont("Helvetica", "bold");
          doc.text("NAVIO:", 0.5, 5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].NOME_NAVIO || "N/A"}`, 2.5, 5);

          doc.setFont("Helvetica", "bold");
          doc.text("DI:", 0.5, 5.5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].NUMERO_DOC || "N/A"}`, 2.5, 5.5);

          doc.setFont("Helvetica", "bold");
          doc.text("PEDIDO:", 0.5, 6);
          doc.setFont("Helvetica", "normal");
          doc.text(
            `${res.data[0].PEDIDO_MIC || "N/A"} - ${
              res.data[0].NOME_DESTINO || "N/A"
            }`,
            2.5,
            6
          );

          doc.setFont("Helvetica", "bold");
          doc.text("PRODUTO:", 0.5, 6.5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PRODUTO || "N/A"}`, 2.5, 6.5);

          doc.setFont("Helvetica", "bold");
          doc.text("CLIENTE:", 0.5, 7.5);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].NOME_CLIENTE || "N/A"}`, 2.1, 7.5);

          doc.setFont("Helvetica", "bold");
          doc.text("TRANSP.:", 0.5, 8);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].NOME_REDUZIDO_TRANSP || "N/A"}`, 2.1, 8);

          doc.setFont("Helvetica", "bold");
          doc.text("PORÃO:", 0.5, 9);
          doc.setFont("Helvetica", "normal");
          doc.text(`${res.data[0].PORAO || "N/A"}`, 2, 9);
          doc.text(
            `DATA CARREG.: ${moment(dataCorrigida).format("DD/MM/YY - HH:mm")}`,
            0.5,
            9.5
          );
          doc.setFont("Helvetica", "bold");
          doc.setFontSize(13);
          doc.text(
            `PESO MOEGA: ${res.data[0].PESO_LIQUIDO_AJUSTADO.toLocaleString(
              "pt-BR",
              { minimumFractionDigits: 0, maximumFractionDigits: 0 }
            )} Kg`,
            0.5,
            10.5
          );

          doc.text(`.`, 0.5, 12);

          // Salvar o PDF
          doc.save(`ticket_pesagem_${res.data[0].ID_CARREGAMENTO}.pdf`);
        }
      })
      .catch(function (err) {
        console.error("Erro ao puxar dados:", err);
      });
  };

  //setI
  const validaDados3 = () => {
    if (!dataFim) {
      showAlert("Preencha a data!", "error");
      return;
    }
    encerrarPeriodo();
  };

  const GerarNotaMIC = async () => {
    if (getVeiculoAtual().STATUS_NOTA_MIC == 4) return;

    const preparaPlaca = (placa) => {
      if (placa == undefined || placa == "") return "";

      return (
        placa.replace(/\s/g, "").slice(0, 3) +
        " " +
        placa.replace(/\s/g, "").slice(3)
      );
    };

    const input_data = {
      placa1: preparaPlaca(i.PLACA_CARRETA),
      placa2: preparaPlaca(i.PLACA_CARRETA2),
      placa3: preparaPlaca(i.PLACA_CARRETA3),
      placaCavalo: preparaPlaca(i.PLACA_CAVALO),
      num_DI: i.NUMERO_DOC,
      pedido_mic: i.PEDIDO_MIC,
      peso_bruto:
        parseFloat(i.PESO_TARA) + parseFloat(i.PESO_CARREGADO || peso2),
      peso_liquido: i.PESO_CARREGADO || peso2,
      tara: 1.0,
      codTiquete: i.TICKET || ticket,
      data: i.DATA_CARREGAMENTO || data,
    };

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://operacao.setlogistica.com.br/api/gerarnotamic/${i.ID_CARREGAMENTO}`,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: input_data,
    };

    await Axios.request(config);
    FecharPesagem();
  };

  const EntregarNotaMIC = async () => {
    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://operacao.setlogistica.com.br/api/entregarnotamic/${i.ID_CARREGAMENTO}`,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
    };

    await Axios.request(config);
    FecharPesagem();
    showAlert("Nota entregue!", "success");
  };

  const datetimeLocal = (datetime) => {
    if (datetime == undefined) return "";

    const dt = new Date(datetime);
    dt.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
    return dt.toISOString().slice(0, 16).replace("T", " ");
  };

  const DownloadNota = async () => {
    const input_data = {
      idCarregamento: i.ID_CARREGAMENTO,
    };

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://operacao.setlogistica.com.br/api/baixarnota`,
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: input_data,
    };

    Axios.request(config)
      .then((res) => {
        var byteCharacters = atob(
          res.data.pdf.split(",")[res.data.pdf.split(",").length - 1]
        );
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], {
          type: res.data.pdf.split(",")[0].split(":")[1],
        });

        const url = URL.createObjectURL(file);
        const link = document.createElement("a");
        link.href = url;
        link.download = res.data.filename;
        link.click();
        URL.revokeObjectURL(url);
      })
      .catch((err) => {
        showAlert("Erro ao obter PDF", "error");
      });
  };

  const SegundaPesagem = () => {
    // Verifica as condições e define o payload
    const payload =
      i.PESO_TARA == 1000
        ? {
            peso2: peso2,
            peso3: peso2 + 1000, // Adiciona 1000 ao peso2
            data: data, // Data formatada
            databruto: data, // Envia o mesmo valor de data para outra coluna
            usuario: usuario,
            usuariobruto: usuario, // Envia o mesmo usuário para outra coluna
            ticket: ticket,
            status: 3, // Atualiza o status para 3
            porao: porao,
            id: i.ID_CARREGAMENTO,
          }
        : {
            peso2: peso2,
            data: data, // Envia apenas data
            usuario: usuario, // Envia apenas usuário
            ticket: ticket,
            status: 2, // Mantém o status como 2
            porao: porao,
            id: i.ID_CARREGAMENTO,
          };

    // Faz a requisição PUT para a API
    Axios.put(
      "https://operacao.setlogistica.com.br/api/segundapesagem",
      payload
    )
      .then(function (res) {
        if (res.data.sqlMessage) {
          // Mostra um alerta em caso de erro no SQL
          showAlert(res.data.sqlMessage, "error");
        } else {
          // Mostra um alerta de sucesso
          showAlert("Veículo pesado com sucesso!", "success");

          // Gera nota fiscal automaticamente se PESO_TARA for 1000
          if (i.PESO_TARA == 1000) {
            GerarNotaMIC();
          }

          // Finaliza o processo de pesagem
          FecharPesagem();
        }
      })
      .catch((error) => {
        // Exibe erros no console
        console.log(error);
      });
  };

  const { enqueueSnackbar } = useSnackbar();
  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  const encerrarPeriodo = () => {
    Axios.put("https://operacao.setlogistica.com.br/api/periodo/finalizar", {
      id: dadosDash.SEQ_PERIODO_OP,
      id_operacao: dadosDash.COD_OPERACAO,
      data: dataFim,
    })
      .then(function (res) {
        if (res.data.sqlMessage) {
          showAlert(res.data.sqlMessage, "error");
        } else {
          showAlert("Período finalizado com sucesso!", "success");
          FecharConfirm();

          // Disparar lógica Hora Hora
          Axios.post("https://operacao.setlogistica.com.br/api/horahora", {
            codOperacao: dadosDash.COD_OPERACAO,
          })
            .then((response) => {
              console.log(
                "Atualização Hora Hora executada com sucesso:",
                response.data
              );
            })
            .catch((error) => {
              console.error(
                "Erro ao executar Atualização Hora Hora:",
                error.response?.data || error.message
              );
            });
        }
      })
      .catch((error) => {
        console.error(
          "Erro ao finalizar o período:",
          error.response?.data || error.message
        );
      });
  };

  const [currentAlertIndex, setCurrentAlertIndex] = useState(0);
  useEffect(() => {
    if (alerta.length > 0) {
      const interval = setInterval(() => {
        setCurrentAlertIndex((prevIndex) => (prevIndex + 1) % alerta.length);
      }, 4000); // Alterna a cada 4 segundos

      return () => clearInterval(interval); // Limpa o intervalo ao desmontar o componente
    }
  }, [alerta]);

  function formatPhone(phone) {
    if (!phone) return "N/A";

    // Remove qualquer caracter não numérico
    const digits = phone.replace(/\D+/g, "");

    // Supondo que o número tenha 11 dígitos (padrão brasileiro: DDD + 9 dígitos)
    // Ex: 11988885555 -> (11) 98888-5555
    if (digits.length === 11) {
      const ddd = digits.substring(0, 2);
      const part1 = digits.substring(2, 7);
      const part2 = digits.substring(7, 11);
      return `(${ddd}) ${part1}-${part2}`;
    }

    // Caso não tenha 11 dígitos, apenas retorna o que tiver
    return digits || "N/A";
  }

  return (
    <>
      <Navbar operacao />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacoes`)}
            >
              Operações
            </div>
            {/* <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/pesagemfinal/${id}`)}
            >
              Pesagem de Conferência
            </div> */}
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/GraficoDocs/${id}`)}
            >
              DashBoard
            </div>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/relatorioautosaberto/${id}`)}
            >
              Autos Em Aberto
            </div>
            <div
              className={style.navItem}
              onClick={() => navigate(`/operacao/${id}/AberturaPeriodo`)}
            >
              Abertura de Período
            </div>
            <div className={style.navItemActive}>{">"} Pesagem Funil</div>
          </div>
          {!dadosDash.SEQ_PERIODO_OP ? (
            <div>
              <div className={style.notform}>
                Tela Bloqueada, aguardando abertura de período.
              </div>
            </div>
          ) : (
            <div>
              <div className={style.flex}>
                <div className={style.periodoContainer}>
                  <div className={style.horario}>
                    {dadosDash.DEN_PERIODO || "--/--"}
                  </div>
                  <div className={style.data}>
                    {moment(dadosDash.INI_PERIODO).format("DD/MM/YYYY") ||
                      "--/--"}
                  </div>
                </div>

                <div></div>
                <div className={style.status}>
                  <div className={`${style[dadosDash.STATUS_OPERACAO]}`}>
                    <i className="fa fa-truck status-icon"></i>
                    <span className="status-text">
                      {dadosDash.STATUS_OPERACAO || "--"}
                    </span>
                  </div>
                </div>
              </div>
              <div className={style.flex}>
                <div className={style.tara}>
                  <div className={style.taratitulo}>
                    Pesagem Funil
                    <div className={style.buscaContainer}>
                      <input
                        type="text"
                        placeholder="Buscar..."
                        onChange={(e) => {
                          setBusca(e.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className={style.sumario}>
                    <div>MOTORISTA</div>
                    <div>CAVALO</div>
                    <div>DATA</div>
                  </div>

                  <div className={style.lista}>
                    {veiculos
                      .filter((val) => {
                        let nome = val.NOME_MOTORISTA.trim().split(" ")[0];
                        let horario = moment(val.DATA_TARA).format(
                          " DD/MM HH:mm"
                        );

                        // NOVA CONDIÇÃO INSERIDA AQUI
                        if (
                          val.PESO_CARREGADO_PY > 0 &&
                          val.PESO_CARREGADO === 0
                        ) {
                          val.COR = "item_status_6";
                        } else {
                          val.COR =
                            "item_status_" +
                            (val.STATUS_NOTA_MIC == 1
                              ? "def"
                              : val.STATUS_NOTA_MIC);
                        }

                        if (busca === "") return val;

                        return (
                          nome.toLowerCase().includes(busca.toLowerCase()) ||
                          val.PLACA_CAVALO.toLowerCase().includes(
                            busca.toLowerCase()
                          ) ||
                          horario.toLowerCase().includes(busca.toLowerCase())
                        );
                      })
                      .map((val, key) => {
                        let nome = val.NOME_MOTORISTA.trim().split(" ")[0];
                        let horario = moment(val.DATA_TARA).format(
                          "DD/MM | HH:mm"
                        );

                        return (
                          <div
                            key={key}
                            className={`${style.item} ${style[val.COR]}`}
                            onClick={() => [AbrirPesagem(), setI(val)]}
                          >
                            <div className={style.item_cell}>{nome || "-"}</div>

                            <div className={style.item_cellPlaca}>
                              <div className={style.placaWrapper}>
                                <img
                                  src={placaMercosul}
                                  alt="Placa Mercosul"
                                  className={style.placaImg}
                                />
                                <span className={style.placaTextoOverlay}>
                                  {val.PLACA_CAVALO || "-"}
                                </span>
                              </div>
                            </div>

                            <div className={style.item_cell}>
                              {horario || "-"}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>

                <div className={style.colunadireita}>
                  <div className={style.paralisacao}>
                    <div className={style.sumariob}>
                      <div className={style.motivobox}>MOTIVO</div>
                      <div className={style.duracaobox}>DURAÇÃO</div>
                    </div>

                    <div className={style.flex}>
                      <div className={style.conteudobox}>
                        <div className={style.listab}>
                          {!paralisacoes.length ? (
                            <div>--</div>
                          ) : (
                            paralisacoes.map((val) => {
                              return (
                                <div className={style.itemb}>
                                  <div>{val.DESC_MOTIVO || "-"}</div>
                                  <div>{val.DURACAO || "-"} min</div>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={style.flexPorao}>
                    <div className={style.pesos2}>
                      <input
                        type="radio"
                        id="porao1"
                        name="porao"
                        onChange={() => {
                          setPorao("1");
                          localStorage.setItem("ultimaSelecaoPorao", "1");
                        }}
                        checked={porao === "1"}
                      />
                      <label htmlFor="porao1">P #1</label>

                      <input
                        type="radio"
                        id="porao2"
                        name="porao"
                        onChange={() => {
                          setPorao("2");
                          localStorage.setItem("ultimaSelecaoPorao", "2");
                        }}
                        checked={porao === "2"}
                      />
                      <label htmlFor="porao2">P #2</label>

                      <input
                        type="radio"
                        id="porao3"
                        name="porao"
                        onChange={() => {
                          setPorao("3");
                          localStorage.setItem("ultimaSelecaoPorao", "3");
                        }}
                        checked={porao === "3"}
                      />
                      <label htmlFor="porao3">P #3</label>

                      <input
                        type="radio"
                        id="porao4"
                        name="porao"
                        onChange={() => {
                          setPorao("4");
                          localStorage.setItem("ultimaSelecaoPorao", "4");
                        }}
                        checked={porao === "4"}
                      />
                      <label htmlFor="porao4">P #4</label>

                      <input
                        type="radio"
                        id="porao5"
                        name="porao"
                        onChange={() => {
                          setPorao("5");
                          localStorage.setItem("ultimaSelecaoPorao", "5");
                        }}
                        checked={porao === "5"}
                      />
                      <label htmlFor="porao5">P #5</label>

                      <input
                        type="radio"
                        id="porao6"
                        name="porao"
                        onChange={() => {
                          setPorao("6");
                          localStorage.setItem("ultimaSelecaoPorao", "6");
                        }}
                        checked={porao === "6"}
                      />
                      <label htmlFor="porao6">P #6</label>

                      <input
                        type="radio"
                        id="porao7"
                        name="porao"
                        onChange={() => {
                          setPorao("7");
                          localStorage.setItem("ultimaSelecaoPorao", "7");
                        }}
                        checked={porao === "7"}
                      />
                      <label htmlFor="porao7">P #7</label>

                      <input
                        type="radio"
                        id="porao8"
                        name="porao"
                        onChange={() => {
                          setPorao("8");
                          localStorage.setItem("ultimaSelecaoPorao", "8");
                        }}
                        checked={porao === "8"}
                      />
                      <label htmlFor="porao8">P #8</label>

                      <input
                        type="radio"
                        id="porao9"
                        name="porao"
                        onChange={() => {
                          setPorao("9");
                          localStorage.setItem("ultimaSelecaoPorao", "9");
                        }}
                        checked={porao === "9"}
                      />
                      <label htmlFor="porao9">P #9</label>

                      <input
                        type="radio"
                        id="porao10"
                        name="porao"
                        onChange={() => {
                          setPorao("10");
                          localStorage.setItem("ultimaSelecaoPorao", "10");
                        }}
                        checked={porao === "10"}
                      />
                      <label htmlFor="porao10">P #10</label>
                    </div>
                  </div>
                </div>
              </div>
              .
              <div className={style.dashboardWrapper}>
                <div className={style.metricsSection}>
                  <div className={style.metricCard}>
                    <span>MANIFESTADO</span>
                    <span>
                      {dadosDash.MANIFESTADO
                        ? (dadosDash.MANIFESTADO / 1000).toLocaleString(
                            "pt-BR",
                            {
                              minimumFractionDigits: 3,
                              maximumFractionDigits: 3,
                            }
                          )
                        : "--"}{" "}
                      TONS
                    </span>
                  </div>
                  <div className={style.metricCard}>
                    <span>DESCARREGADO</span>
                    <span>
                      {descarregadoh
                        ? (descarregadoh / 1000).toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })
                        : "0"}{" "}
                      TONS
                    </span>
                  </div>
                  <div
                    className={`${style.metricCard} ${
                      dadosDash.MANIFESTADO &&
                      descarregadoh &&
                      (dadosDash.MANIFESTADO - descarregadoh) / 1000 < 100
                        ? style.alertCard
                        : ""
                    }`}
                  >
                    <span>SALDO</span>
                    <span>
                      {dadosDash.MANIFESTADO && descarregadoh
                        ? (
                            (dadosDash.MANIFESTADO - descarregadoh) /
                            1000
                          ).toLocaleString("pt-BR", {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3,
                          })
                        : "--"}{" "}
                      TONS
                    </span>
                  </div>
                </div>

                {alerta.length > 0 && (
                  <div className={style.alertsSection}>
                    {alerta.map((pedido, index) => {
                      if (index === currentAlertIndex) {
                        const saldoManifestado =
                          pedido.QTDE_MANIFESTADA_PEDIDO / 1000 -
                          pedido.PESO_LIQUIDO_POR_PEDIDO / 1000;
                        if (saldoManifestado < 100) {
                          return (
                            <div
                              className={`${style.alertBox} ${style.blink}`}
                              key={pedido.PEDIDO_MIC_ALERTA}
                            >
                              <div>
                                <i
                                  className="fa fa-exclamation-circle"
                                  aria-hidden="true"
                                ></i>{" "}
                                ALERTA - PEDIDO
                              </div>
                              <span>
                                PEDIDO: {pedido.PEDIDO_MIC_ALERTA} - SALDO:{" "}
                                {saldoManifestado.toLocaleString("pt-BR")} TONS
                              </span>
                            </div>
                          );
                        }
                      }
                      return null;
                    })}
                  </div>
                )}
              </div>
              <div className={style.flex}>
                <button
                  className={style.abrirp}
                  onClick={
                    dadosDash.STATUS_OPERACAO == "OPERANDO"
                      ? AbrirParalisacao
                      : AbrirParalisacaoFim
                  }
                >
                  {dadosDash.STATUS_OPERACAO == "OPERANDO"
                    ? "ABRIR PARALISAÇÃO"
                    : "ENCERRAR PARALISAÇÃO"}
                </button>
                <div className={style.navio}>
                  <i className="fa fa-ship icon"></i>&nbsp;&nbsp;&nbsp;
                  {dadosDash.NOME_NAVIO || "--"}
                </div>
                <button
                  className={style.finalizar}
                  disabled={isButtonDisabled} // Desabilita o botão se o estado for true
                  onClick={() => {
                    if (dadosDash.STATUS_OPERACAO == "PARALISADO") {
                      showAlert(
                        "É necessário ENCERRAR A PARALISAÇÃO para finalizar este período",
                        "error"
                      );
                    } else {
                      AbrirConfirm();
                      setIsButtonDisabled(true); // Desabilita o botão
                      setTimeout(() => {
                        setIsButtonDisabled(false); // Reabilita o botão após 10 segundos
                      }, 30000); // 10 segundos
                    }
                  }}
                >
                  FINALIZAR ESTE PERÍODO
                </button>
              </div>
            </div>
          )}
        </div>
      </Container>
      <Pesagem open={openA} onClose={FecharPesagem} fullWidth>
        <div className={modal.modal}>
          <div className={modal.nav}>
            {/* Nome do Navio e ícone */}
            <div className={modal.line}>
              <span>MV {dadosDash.NOME_NAVIO || "--"}</span>
            </div>

            {/* ID Carregamento, alinhado à direita */}
            <div className={modal.line}>
              <b>ID:</b>
              <span onClick={() => copyToClipboardFallback(i.ID_CARREGAMENTO)}>
                {i.ID_CARREGAMENTO}
              </span>
            </div>
          </div>

          <div className={modal.tableContainer}>
            <table className={modal.table}>
              <tbody>
                {/* Linha para Motorista */}
                <tr className={modal.DoubleColumn2}>
                  <th>Motorista</th>
                  <td className={modal.flexinline}>{i.NOME_MOTORISTA}</td>
                  <th>Whatsapp</th>
                  <td className={modal.flexinline}>
                    {mostaInput13 ? (
                      <>
                        <InputMask
                          mask="(99) 99999-9999"
                          value={whatsapp}
                          onChange={(e) => {
                            // Remove qualquer caractere que não seja dígito
                            const valorAjustado = e.target.value.replace(
                              /\D+/g,
                              ""
                            );
                            setWhatsapp(valorAjustado.toUpperCase());
                          }}
                          placeholder="Whatsapp"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaWhatsapp();
                            setMostaInput13(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput13(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.CELULAR_MOTORISTA
                          ? formatPhone(i.CELULAR_MOTORISTA)
                          : "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput13(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>

                {/* Linha para Cavalo e 1ª Carreta */}
                <tr className={modal.DoubleColumn}>
                  <th>Pl. Cavalo</th>
                  <td className={modal.flexinline}>
                    {mostaInput2 ? (
                      <>
                        <input
                          onChange={(e) =>
                            setPlacaCavalo(e.target.value.toUpperCase())
                          }
                          placeholder="Placa do cavalo"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaCavalo();
                            setMostaInput2(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput2(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.PLACA_CAVALO}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput2(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>

                  <th>1° Carreta</th>
                  <td className={modal.flexinline}>
                    {mostaInput3 ? (
                      <>
                        <input
                          onChange={(e) =>
                            setPlaca1(e.target.value.toUpperCase())
                          }
                          placeholder="Placa 1"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaPlaca1();
                            setMostaInput3(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput3(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.PLACA_CARRETA}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput3(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>

                {/* Linha para 2ª e 3ª Carreta */}
                <tr className={modal.DoubleColumn2}>
                  <th>2° Carreta</th>
                  <td className={modal.flexinline}>
                    {mostaInput4 ? (
                      <>
                        <input
                          onChange={(e) =>
                            setPlaca2(e.target.value.toUpperCase())
                          }
                          placeholder="Placa 2"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaplaca2();
                            setMostaInput4(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput4(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.PLACA_CARRETA2 || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput4(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>

                  <th>3° Carreta</th>
                  <td className={modal.flexinline}>
                    {mostaInput5 ? (
                      <>
                        <input
                          placeholder="Placa 3"
                          className={modal.inputline}
                          onChange={(e) =>
                            setPlaca3(e.target.value.toUpperCase())
                          }
                        />
                        <button
                          onClick={() => {
                            validaplaca3();
                            setMostaInput5(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput5(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.PLACA_CARRETA3 || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput5(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>
                {/* Linha para Modelo */}
                <tr className={modal.DoubleColumn2}>
                  <th>Modelo</th>
                  <td className={modal.flexinline}>
                    {mostaInput7 ? (
                      <>
                        <select
                          className={modal.inputline}
                          onChange={(e) => setTipoveiculo(e.target.value)}
                        >
                          <option disabled selected>
                            Selecione uma opção
                          </option>
                          {tipoveiculos.map((val) => (
                            <option key={val.COD_TIPO} value={val.COD_TIPO}>
                              {val.DESC_TIPO_VEICULO} -{" "}
                              {val.CAPACIDADE.toLocaleString("pt-BR")} KG
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => {
                            validaVeiculo();
                            setMostaInput7(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput7(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.DESC_TIPO_VEICULO || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput7(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                  <th>Produto</th>
                  <td className={modal.flexinline}>
                    {i.NOME_REDUZIDO_PRODUTO}
                  </td>
                </tr>

                {/* Linha para 1º Pesagem (Tara) */}
                <tr className={modal.DoubleColumn2}>
                  <th>1º Pesagem (Tara)</th>
                  <td className={modal.flexinline}>
                    {mostaInput6 ? (
                      <>
                        <input
                          onChange={(e) => setTara(e.target.value)}
                          placeholder="Peso da TARA"
                          className={modal.inputline}
                        />
                        <input
                          onChange={(e) => setDataTara(e.target.value)}
                          placeholder="Data da TARA"
                          className={modal.inputlinedate}
                          type="datetime-local"
                        />
                        <button
                          onClick={() => {
                            validaTara();
                            setMostaInput6(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput6(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {`${i.PESO_TARA} KG`}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput6(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>

                {/* Linha para DI e Pedido */}
                <tr className={modal.DoubleColumn2}>
                  <th>DI</th>
                  <td className={modal.flexinline}>
                    {mostaInput10 ? (
                      <>
                        <select
                          className={modal.inputline}
                          onChange={(e) => setDocdibl(e.target.value)}
                        >
                          <option disabled selected>
                            Selecione uma opção
                          </option>
                          {dicargas.map((val) => (
                            <option key={val.COD_CARGA} value={val.COD_CARGA}>
                              {val.NUMERO_DOC}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => {
                            validaDocdibl();
                            setMostaInput10(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput10(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.NUMERO_DOC}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput10(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>

                  <th>Pedido</th>
                  <td className={modal.flexinline}>
                    {mostaInput8 ? (
                      <>
                        <select
                          className={modal.inputline}
                          onChange={(e) => setDocumento(e.target.value)}
                        >
                          <option disabled selected>
                            Selecione uma opção
                          </option>
                          {pedidos.map((val) => (
                            <option key={val.NR_PEDIDO} value={val.NR_PEDIDO}>
                              {val.NR_PEDIDO}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => {
                            validaDoc();
                            setMostaInput8(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput8(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.PEDIDO_MIC || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput8(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>

                {/* Linha para Transportadora */}
                <tr className={modal.DoubleColumn2}>
                  <th>Transportadora</th>
                  <td className={modal.flexinline}>
                    {mostaInput9 ? (
                      <>
                        <select
                          className={modal.inputline}
                          onChange={(e) => setTransportadora(e.target.value)}
                        >
                          <option disabled selected>
                            Selecione uma opção
                          </option>
                          {transportadoras.map((val) => (
                            <option key={val.COD_TRANSP} value={val.COD_TRANSP}>
                              {val.NOME_REDUZIDO}
                            </option>
                          ))}
                        </select>
                        <button
                          onClick={() => {
                            validaTransportadora();
                            setMostaInput9(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput9(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.NOME_TRANSPORTADORA}
                        <span
                          className={modal.editicon}
                          onClick={() => setMostaInput9(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>

                  <th>Minuta</th>
                  <td className={modal.flexinline}>
                    {mostaInput11 ? (
                      <>
                        <input
                          onChange={(e) =>
                            setMinuta(e.target.value.toUpperCase())
                          }
                          placeholder="Minuta"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaMinuta();
                            setMostaInput11(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput11(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.MINUTA || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput11(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>

                {/* Linha para Observação */}
                <tr className={modal.DoubleColumn2}>
                  <th>Observação</th>
                  <td className={modal.flexinline}>
                    {mostaInput12 ? (
                      <>
                        <input
                          onChange={(e) =>
                            setObservacao(e.target.value.toUpperCase())
                          }
                          placeholder="Observacao"
                          className={modal.inputline}
                        />
                        <button
                          onClick={() => {
                            validaObservacao();
                            setMostaInput12(false);
                          }}
                          className={modal.buttontline}
                        >
                          <i className="fa fa-check" />
                        </button>
                        <button
                          onClick={() => setMostaInput12(false)}
                          className={modal.buttontlinecancel}
                        >
                          <i className="fa fa-times" />
                        </button>
                      </>
                    ) : (
                      <>
                        {i.OBS_CARREGAMENTO || "N/A"}
                        <span
                          className="edit-icon"
                          onClick={() => setMostaInput12(true)}
                        >
                          ✏️
                        </span>
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className={modal.periodo}>
            {getVeiculoAtual().PESO_TARA == 1000 &&
              getVeiculoAtual().STATUS_CARREG >= 3 && (
                <div className={modal.nota}>
                  <h1>
                    <strong>MIC Sistemas</strong>
                  </h1>
                  <div className={modal.nota_container}>
                    <div className={modal.gera_nota_group}>
                      {getVeiculoAtual().STATUS_NOTA_MIC == 4 && (
                        <div
                          className={modal.gera_nota}
                          onClick={() => {
                            if (getVeiculoAtual().STATUS_NOTA_MIC === 4) {
                              DownloadNota(); // Função para baixar a nota fiscal
                              EntregarNotaMIC(); // Função para marcar como entregue
                            }
                          }}
                        >
                          <i className="fa fa-file-pdf icon"></i>
                          BAIXAR Nota Fiscal
                        </div>
                      )}
                      {![2, 4, 5].includes(
                        getVeiculoAtual().STATUS_NOTA_MIC
                      ) && (
                        <div className={modal.gera_nota} onClick={GerarNotaMIC}>
                          <i className="fa fa-file-pdf icon"></i>
                          GERAR NF
                        </div>
                      )}
                    </div>

                    <div className={modal.status_group}>
                      {getVeiculoAtual().STATUS_NOTA_MIC != 4 && (
                        <label
                          className={
                            modal[
                              `obs_nota_status_${
                                getVeiculoAtual().STATUS_NOTA_MIC < 3
                                  ? "def"
                                  : getVeiculoAtual().STATUS_NOTA_MIC
                              }`
                            ]
                          }
                        >
                          {getVeiculoAtual().OBS_NOTA}
                        </label>
                      )}
                    </div>
                  </div>
                </div>
              )}
          </div>

          <div className={modal.flex3}>
            <div className={modal.inputbox_pesagem3}>
              2º Pesagem
              <div className={modal.pesagem_linha3}>
                <input
                  type="text"
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/[^\d]/g, "");
                    setPeso2(rawValue);
                  }}
                  value={
                    peso2
                      ? `${parseInt(peso2, 10).toLocaleString("pt-BR")} KG`
                      : ""
                  }
                  disabled={true}
                />
                <input
                  type="text"
                  onChange={(e) => setData(e.target.value)}
                  value={data ? moment(data).format("DD/MM HH:mm") : ""}
                  disabled={true}
                />
              </div>
            </div>

            <div className={modal.inputbox_ticket3}>
              Ticket
              <input
                type="text"
                onChange={(e) => {
                  setTicket(e.target.value);
                }}
                placeholder={getVeiculoAtual().TICKET}
                disabled={getVeiculoAtual().STATUS_CARREG == 3}
              />
            </div>

            <div className={modal.inputbox3}>
              {getVeiculoAtual().IND_CARGA_IMO === "S" && (
                <>
                  <img src={seloBase64} alt="Selo" />
                  <div
                    onClick={abrirGifAdesivo}
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      backgroundColor: "#ccc",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "16px",
                    }}
                    title="Ver demonstração"
                  >
                    ?
                  </div>
                </>
              )}

              {mostrarGifAdesivo && (
                <div
                  onClick={fecharGifAdesivo}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                  }}
                >
                  <div
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      backgroundColor: "#fff",
                      padding: "20px",
                      borderRadius: "8px",
                      maxWidth: "90%",
                      maxHeight: "90%",
                      overflow: "auto",
                    }}
                  >
                    <img
                      src="https://exemplo.com/gif-adesivando.gif"
                      alt="Demonstração Adesivando"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className={modal.flex}>
            <button className={style.finalizar} onClick={puxarPY}>
              GERAR TICKET
            </button>
            <button
              className={style.finalizar}
              onClick={validaDados2}
              disabled={getVeiculoAtual().STATUS_CARREG == 3}
            >
              GERAR NOTA
            </button>
          </div>
        </div>
      </Pesagem>
      <Paralisacao open={openB} onClose={FecharParalisacao} fullWidth>
        <div className={modal.modal}>
          <div className={modal.nav}>
            <div onClick={FecharParalisacao}>Voltar</div>
            <div className={modal.active}>Abertura de Paralisação</div>
          </div>
          <div className={modal.flex}>
            <div className={modal.periodo}>
              {dadosDash.DEN_PERIODO || "--/--"}
              <div className={modal.data}>
                {/* 02/01/2023 */}
                {moment(dadosDash.INI_PERIODO).format("DD/MM/YYYY") || "--/--"}
              </div>
            </div>
            <div className={modal.inputbox}>
              Início
              <input
                type="datetime-local"
                onChange={(e) => {
                  setDtinicio(e.target.value);
                }}
              />
            </div>
          </div>
          <div className={modal.selectbox}>
            <label>Motivo:</label>
            <select
              onChange={(e) => {
                setMotivo(e.target.value);
              }}
            >
              <option disabled selected>
                Selecione uma opção
              </option>
              {motivos?.map((val) => {
                return (
                  <option value={val.COD_MOTIVO}>{val.DESC_MOTIVO} </option>
                );
              })}
            </select>
          </div>
          <div className={modal.selectbox}>
            <label>Complemento:</label>
            <select
              onChange={(e) => {
                setComplemento(e.target.value);
              }}
            >
              <option disabled selected>
                Selecione uma opção
              </option>
              {complementos?.map((val) => {
                return <option value={val.COD_COMPL}>{val.DESC_COMPL}</option>;
              })}
            </select>
          </div>
          <div className={modal.flex}>
            <div className={modal.textbox}>
              Observação
              <textarea
                rows="4"
                onChange={(e) => setObs(e.target.value)}
              ></textarea>
            </div>
          </div>

          <div className={modal.flex}>
            <div className={style.navio}>
              <i className="fa fa-ship icon"></i>&nbsp;&nbsp;&nbsp;
              {dadosDash.NOME_NAVIO || "--"}
            </div>
            <button className={style.finalizar} onClick={validaDados1}>
              REGISTRAR PARALISAÇÃO
            </button>
          </div>
        </div>
      </Paralisacao>
      <Confirm open={openC} onClose={FecharConfirm} fullWidth>
        <div className={confirm.modal}>
          <div className={confirm.nav}>
            <div onClick={FecharConfirm}>Voltar</div>
          </div>
          <div className={confirm.center}>
            Deseja finalizar o período atual?
            <br />
          </div>
          <div className={confirm.center}>
            <div className={confirm.inputbox}>
              Registre o Horário:
              <input
                type="datetime-local"
                onChange={(e) => {
                  setDataFim(e.target.value);
                }}
              />
            </div>
          </div>
          <br></br>
          <div className={confirm.flex}>
            <div className={confirm.navio}>
              <i className="fa fa-ship icon"></i>&nbsp;&nbsp;&nbsp;
              {dadosDash.NOME_NAVIO || "--"}
            </div>
            <button
              className={confirm.confirmar}
              onClick={() => {
                validaDados3();
                setIsConfirmDisabled(true); // Desabilita o botão
                setTimeout(() => {
                  setIsConfirmDisabled(false); // Reabilita o botão após 10 segundos
                }, 20000); // 20 segundos
              }}
              disabled={isConfirmDisabled} // Controla o estado de desabilitação
            >
              CONFIRMAR
            </button>
          </div>
        </div>
      </Confirm>
      <ParalisacaoFim open={openD} onClose={FecharParalisacaoFim} fullWidth>
        <div className={confirm.modal}>
          <div className={confirm.nav}>
            <div onClick={FecharParalisacaoFim}>Voltar</div>
          </div>
          <br />
          <div className={confirm.center}>
            Deseja finalizar paralisação atual?
            <br />
          </div>
          <div className={confirm.center}>
            <div className={confirm.inputbox}>
              Registre o horário:
              <input
                type="datetime-local"
                onChange={(e) => {
                  setDataFimPara(e.target.value);
                }}
              />
            </div>
          </div>
          <br></br>
          <div className={confirm.flex}>
            <button className={confirm.cancelar} onClick={FecharParalisacaoFim}>
              CANCELAR
            </button>
            <div className={confirm.navio}>
              <i className="fa fa-ship icon"></i>&nbsp;&nbsp;&nbsp;
              {dadosDash.NOME_NAVIO || "--"}
            </div>
            <button className={confirm.confirmar} onClick={validaPara}>
              CONFIRMAR
            </button>
          </div>
        </div>
      </ParalisacaoFim>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={3500}
    >
      <Operacao />
    </SnackbarProvider>
  );
}
